export const TooltipPositionToTippyPlacementMap = {
  'top-start': 'top-start',
  'top-middle': 'top',
  'top-end': 'top-end',
  'right-start': 'right-start',
  'right-middle': 'right',
  'right-end': 'right-end',
  'bottom-start': 'bottom-start',
  'bottom-middle': 'bottom',
  'bottom-end': 'bottom-end',
  'left-start': 'left-start',
  'left-middle': 'left',
  'left-end': 'left-end'
};
export const TooltipPositionToTippyOffsetMap = {
  'top-start': [-6, 8],
  'top-middle': [0, 8],
  'top-end': [6, 8],
  'right-start': [-6, 8],
  'right-middle': [0, 8],
  'right-end': [6, 8],
  'bottom-start': [-6, 8],
  'bottom-middle': [0, 8],
  'bottom-end': [6, 8],
  'left-start': [-6, 8],
  'left-middle': [0, 8],
  'left-end': [6, 8]
};
export const TooltipPositionToArrowOffsetMap = {
  'top-start': '24px',
  'top-middle': '50%',
  'top-end': '24px',
  'right-start': '24px',
  'right-middle': '50%',
  'right-end': '24px',
  'bottom-start': '24px',
  'bottom-middle': '50%',
  'bottom-end': '24px',
  'left-start': '24px',
  'left-middle': '50%',
  'left-end': '24px'
};
export function getTransform(position) {
  switch (position) {
    case 'top-start':
      return 'translateX(-50%) translateY(50%) rotate(45deg);';
    case 'top-middle':
      return 'translateX(-50%) translateY(50%) rotate(45deg);';
    case 'top-end':
      return 'translateX(50%) translateY(50%) rotate(45deg);';
    case 'right-start':
      return 'translateX(-50%) translateY(-50%) rotate(45deg);';
    case 'right-middle':
      return 'translateX(-50%) translateY(-50%) rotate(45deg);';
    case 'right-end':
      return 'translateX(-50%) translateY(50%) rotate(45deg);';
    case 'bottom-start':
      return 'translateX(-50%) translateY(-50%) rotate(45deg);';
    case 'bottom-middle':
      return 'translateX(-50%) translateY(-50%) rotate(45deg);';
    case 'bottom-end':
      return 'translateX(50%) translateY(-50%) rotate(45deg);';
    case 'left-start':
      return 'translateX(50%) translateY(-50%) rotate(45deg);';
    case 'left-middle':
      return 'translateX(50%) translateY(-50%) rotate(45deg);';
    case 'left-end':
      return 'translateX(50%) translateY(50%) rotate(45deg);';
    default:
      console.error(`[Tooltip]: unknown position: ${position}!`);
      return 'none';
  }
}
export function getTopPosition(position, offset) {
  switch (position) {
    case 'top-start':
    case 'top-middle':
    case 'top-end':
    case 'right-end':
    case 'left-end':
      return 'auto';
    case 'right-start':
    case 'right-middle':
    case 'left-start':
    case 'left-middle':
      return offset;
    case 'bottom-start':
    case 'bottom-middle':
    case 'bottom-end':
      return '0';
    default:
      console.error(`[Tooltip]: unknown position: ${position}!`);
      return 'auto';
  }
}
export function getRightPosition(position, offset) {
  switch (position) {
    case 'top-start':
    case 'top-middle':
    case 'right-start':
    case 'right-middle':
    case 'right-end':
    case 'bottom-start':
    case 'bottom-middle':
      return 'auto';
    case 'top-end':
    case 'bottom-end':
      return offset;
    case 'left-end':
    case 'left-start':
    case 'left-middle':
      return '0';
    default:
      console.error(`[Tooltip]: unknown position: ${position}!`);
      return 'auto';
  }
}
export function getBottomPosition(position, offset) {
  switch (position) {
    case 'top-start':
    case 'top-middle':
    case 'top-end':
      return '0';
    case 'right-end':
    case 'left-end':
      return offset;
    case 'bottom-start':
    case 'bottom-middle':
    case 'bottom-end':
    case 'right-start':
    case 'right-middle':
    case 'left-start':
    case 'left-middle':
      return 'auto';
    default:
      console.error(`[Tooltip]: unknown position: ${position}!`);
      return 'auto';
  }
}
export function getLeftPosition(position, offset) {
  switch (position) {
    case 'top-start':
    case 'top-middle':
    case 'bottom-start':
    case 'bottom-middle':
      return offset;
    case 'top-end':
    case 'bottom-end':
    case 'left-end':
    case 'left-start':
    case 'left-middle':
      return 'auto';
    case 'right-start':
    case 'right-end':
    case 'right-middle':
      return '0';
    default:
      console.error(`[Tooltip]: unknown position: ${position}!`);
      return 'auto';
  }
}